
export default function apiConfig (Restangular) {
  'ngInject'
  return function (propertyName, value) {
    Restangular.configuration[propertyName] = value
  }
}
